import React from "react";
import PresidentWord from "@/components/PresidentWord";

export default function PresidentPage() {
  return (
    <>
      <PresidentWord />
    </>
  );
}
